import { CloseOutlined, LoadingOutlined } from "@ant-design/icons";
import { Button, Form, Spin } from "antd";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import CustomInput from "../../../global/components/inputWidgets/CustomInput";
import { getEnageUser } from "../../../global/hooks/getUserRole";
import CustomSelect from "../../../global/components/inputWidgets/CustomSelect";
import usePostEngageLogin from "../../../global/hooks/usePostEngageLogin";
import { useEffect } from "react";
import {
  openConfirmNotification,
  openErrorNotification,
} from "../../../global/utils/toast";
import { normalizeEmailValue } from "../../../global/utils/normalizeFormEmails";

const OperatorInviteForm = ({ setOperatorInviteModal, siteRefrence }) => {
  const user = getEnageUser();
  const [form] = Form.useForm();

  const postUrl = `${process.env.REACT_APP_API_URL}/api/engage/sites-operator-invite`;
  const {
    data: postData,
    loading: postLoading,
    error: postError,
    postData: postAction,
  } = usePostEngageLogin(postUrl);
  const handleSubmit = async (values) => {
    const body = {
      ...values,
      Email: normalizeEmailValue(values.Email),
      UserName: user?.username,
      PassWord: user?.password,
      SiteReference: siteRefrence,
    };
    await postAction(body);
  };

  useEffect(() => {
    if (postData && postData?.status === 200 && !postError) {
      if (postData?.data?.status === 400) {
        openErrorNotification(
          postData?.data?.message || "Something went wrong"
        );
      } else if (postData?.data?.status === 201) {
        openConfirmNotification("Success");
        setOperatorInviteModal(false);
        form.resetFields();
      }
    } else {
      if (postError) {
        openErrorNotification("Something went wrong");
      }
    }
  }, [postData]);

  //   console.log("postData", postData);
  return (
    <>
      <Form
        validateTrigger={"onChange"}
        form={form}
        onFinish={null}
        scrollToFirstError
        layout={"vertical"}
        autoComplete={"off"}
      >
        <div className={`bg-white overflow-hidden`}>
          <div className="px-2 pt-1 pb-3">
            <CustomInput label="Email" name="Email" required />
            <CustomSelect
              label="Role"
              name="Role"
              required
              options={[
                { label: "Site Admin", value: "SiteAdmin" },
                { label: "Manager", value: "Manager" },
                { label: "Operator", value: "Operator" },
              ]}
            />
          </div>
        </div>
      </Form>

      <div className="flex justify-center space-x-2 mt-2.5">
        <Button
          type="primary"
          className="mr-2 min-w-[104px] h-[30px] py-1 px-[10px] font-medium flex items-center "
          onClick={() => {
            form.validateFields().then((values) => handleSubmit(values));
          }}
        >
          {postLoading ? (
            <Spin
              indicator={
                <LoadingOutlined
                  spin
                  className="h-4 w-4"
                  style={{ color: "white" }}
                />
              }
            />
          ) : (
            <div className="flex items-center gap-1">
              <IoIosCheckmarkCircleOutline className="!text-[14px] font-medium" />
              <span className="">Apply</span>
            </div>
          )}
        </Button>
        <Button
          className="reset-button"
          onClick={() => setOperatorInviteModal(false)}
        >
          <CloseOutlined />
          <span className="">Cancel</span>
        </Button>
      </div>
    </>
  );
};

export default OperatorInviteForm;
